export default {
  buttons: {
    send_code: 'Inlogcode versturen',
  },
  placeholders: {
    mobile_number: 'Mobiel nummer',
    email: 'E-mailadres',
  },
  feedback: {
    phone_number_required: 'Voer je telefoonnummer in',
    email_required: 'Voer je e-mailadres in',
  },
};
